import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

/**
 * Rotas do módulo da plataforma.
 *
 * `/admin/reports` é a fila de triagem de denúncias. Ela **exige sessão** — a
 * RPC `is_platform_admin()` responde `false` para quem não tem conta —, então
 * entra sob o `RequireSession` que fica **dentro** do `AppLayout`, ao lado de
 * `/requests`, `/calls` e `/notes`: é tela-destino de listagem, alcançada pelo
 * menu, e não fluxo de tarefa (estes montam fora do layout, sem a barra).
 *
 * A própria página redireciona quem não é da plataforma. O guard de rota
 * garante a sessão; a RLS garante o dado.
 */

const AlertsAdminPage = lazy(() => import('./routes/AlertsAdmin.page'));
const ContentAdminPage = lazy(() => import('./routes/ContentAdmin.page'));
const ReportQueuePage = lazy(() => import('./routes/ReportQueue.page'));
// O painel (`AdminHome`) e a tela de contas nascem no plano do painel do
// admin (F1, 2026-08-27): `admin` é o índice da fila de rotas de `/admin/*`
// que as demais frentes registram aqui do lado.
const AdminHomePage = lazy(() => import('./routes/AdminHome.page'));
const AdminAccountsPage = lazy(() => import('./routes/AdminAccounts.page'));
const AdminRequestsPage = lazy(() => import('./routes/AdminRequests.page'));
const PlatformPinsPage = lazy(() => import('./routes/PlatformPins.page'));

export const platformRoutes: RouteObject[] = [
  { path: 'admin', element: <AdminHomePage /> },
  { path: 'admin/accounts', element: <AdminAccountsPage /> },
  { path: 'admin/alerts', element: <AlertsAdminPage /> },
  { path: 'admin/content', element: <ContentAdminPage /> },
  { path: 'admin/pins', element: <PlatformPinsPage /> },
  { path: 'admin/reports', element: <ReportQueuePage /> },
  { path: 'admin/requests', element: <AdminRequestsPage /> },
];
